import { cardItems } from '@/mocks/homeData';

export default function Cards() {
  return (
    <section id="cards" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-sm text-foreground-500">编辑团队为你精心挑选</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-colors duration-200 hover:bg-background-50/80"
            >
              <div className="relative w-full h-[200px] md:h-[220px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-secondary-500 text-background-50 text-xs font-medium rounded-md">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}